module.exports={render:function (){var _vm=this;
  return _vm._h('ul', {
    staticClass: "label-list"
  }, [_vm._l((_vm.list), function(label, index) {
    return _vm._h('li', {
      staticClass: "label",
      class: {
        'selected': _vm.selected === index
      },
      on: {
        "click": function($event) {
          _vm.clickHandler(index)
        }
      }
    }, [_vm._s(label)])
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8fc0a384!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelList.vue
// module id = 11
// module chunks = 1